/**
 * 인증 흐름 공통 상수 SSoT.
 * 로그인 유도 직전 보존하는 단발성 흐름 상태(복귀지·보류 담기 의도 등)의 수명을 한곳에서 관리한다.
 */

/**
 * 로그인 흐름 보류 상태의 유효 기간(ms) — 10분.
 *
 * 비로그인 사용자가 보호 동작(담기 등)에서 로그인으로 유도될 때 보존하는 상태(returnUrl·pendingAddId)의 TTL.
 * 사용자가 로그인하지 않고 이탈하면 이 시간 뒤 자동 폐기돼, 한참 뒤 같은 탭에서 잊힌 동작이 되살아나는 것을 막는다.
 * 백엔드 회원가입 핸드오프(signup_handoff, 002)의 단기 TTL(10분)과 의도적으로 동일하게 맞춰 흐름 수명을 일관화한다.
 */
export const LOGIN_FLOW_TTL_MS = 10 * 60 * 1000;
